import { Col, Row } from "antd";
import React from "react";
import Banner from "./component/Banner";
import Option from "./component/Option";
import Overview from "./component/Overview";
import Styling from "./component/Styling";
import Theme from "./component/Theme";
import Usage from "./component/Usage";

export default function GuideLinePage() {
  return (
    <Row className="guideline">
      <Col xs={24}>
        <Banner />
      </Col>
      <Col className="section-wrapper" xs={24}>
        <div className="section page-container">
          <a href="/">
            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                marginBottom: 40,
              }}
            >
              <img src="/icon/back.svg" alt="" />
              <p className="w-font-md fw-600 color-text-secondary">
                Back to homepage
              </p>
            </div>
          </a>
          <Overview />
        </div>
      </Col>
      <Col className="section-wrapper" xs={24}>
        <div className="section page-container">
          <Usage />
        </div>
      </Col>
      <Col className="section-wrapper" xs={24}>
        <div className="section page-container">
          <Option />
        </div>
      </Col>
      <Col className="section-wrapper" xs={24}>
        <div className="section page-container">
          <Styling />
        </div>
      </Col>

      <Col className="section-wrapper" xs={24}>
        <div className="section page-container">
          <Theme />
        </div>
      </Col>
    </Row>
  );
}
